module.exports = __webpack_public_path__ + "img/fr_ca.ea4437da.svg";